import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../reducers';

export const getRolesState = createSelector(getDragonflySharedState, (state) => state.roles);

export const getRoles = createSelector(getRolesState, ({ roles }) => roles);

export const getRolesLoaded = createSelector(getRolesState, ({ loaded }) => loaded);
